import { IconDefinition } from "./types";

const linkedin: IconDefinition = {
  iconName: "linkedin",
  width: 16,
  height: 16,
  svgPathData:
    "M3.8,2.53333333 C3.8,3.454 3.05333333,4.2 2.13333333,4.2 C1.21266667,4.2 0.466666667,3.454 0.466666667,2.53333333 C0.466666667,1.61333333 1.21266667,0.866666667 2.13333333,0.866666667 C3.05333333,0.866666667 3.8,1.61333333 3.8,2.53333333 Z M10.4806667,8.77133333 C9.69133333,8.77133333 9.052,9.41133333 9.052,10.2 L9.052,15.0333333 L5.64733333,15.0333333 L5.64733333,5.748 L9.052,5.748 L9.052,6.80866667 C9.052,6.80866667 10.1946667,5.74066667 11.902,5.74066667 C14.018,5.74066667 15.4806667,7.30866667 15.4806667,10.2806667 L15.4806667,15.0333333 L11.9093333,15.0333333 L11.9093333,10.2 C11.9093333,9.41133333 11.27,8.77133333 10.4806667,8.77133333 Z M0.514,15.0333333 L3.752,15.0333333 L3.752,5.748 L0.514,5.748 L0.514,15.0333333 Z",
  iconType: "fill",
};

export { linkedin };
